import { render, staticRenderFns } from "./expense.vue?vue&type=template&id=1d6f02d3&scoped=true"
import script from "./expense.vue?vue&type=script&lang=js"
export * from "./expense.vue?vue&type=script&lang=js"
import style0 from "./expense.vue?vue&type=style&index=0&id=1d6f02d3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d6f02d3",
  null
  
)

export default component.exports